<template>
    <div class="mb-4">
        <FormField :field="form.user.fields.email" namespace="user" :name="'email'" />
        <p v-if="state.user_exists_message" class="text-sm mt-1">{{ state.user_exists_message }}</p>
    </div>
</template>

<script>
import {computed, watch, onMounted, reactive, ref} from 'vue'
import { useAccountStore } from "@sto/account.store"
import { useUserStore } from '@sto/user.store'
import { useAuctioneerStore } from '@sto/auctioneer.store'
import {getConfigurationValue, isValid, isValidField} from '@lib/helpers'
import CrossIcon from "@ico/CrossIcon.vue";
import AssetAddToSale from "@par/asset/AssetAddToSale.vue";
import CheckCircleFillIcon from "@ico/CheckCircleFillIcon.vue";
export default {
    components: {CheckCircleFillIcon, AssetAddToSale, CrossIcon},
    props: ['auctioneer_id'],
    setup(props, {emit}) {

        const ACCOUNT_STORE = useAccountStore()
        const AUCTIONEER_STORE = useAuctioneerStore()
        const USER_STORE = useUserStore()

        const state = reactive({
            user_check_loading: false,
            user_check_timeout: null,
            user_check_min_length: 3,
            user_exists_message: null
        })

        const form = reactive({
            user: {
                loading: false,
                fields: {
                    email: {
                        active: true,
                        label: 'Email address',
                        type: 'text',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [
                            {type: 'characters', value: 'email'},
                        ],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                }
            }
        })

        const getSimilarUsers = async () => {

            if (state.user_check_loading || !isValid(form.user.fields)) return

            try {
                state.user_check_loading = true
                // check for an existing user
                const users = await USER_STORE.search([{ key: 'email', value: form.user.fields.email.value }])

                if (Array.isArray(users?.users) && users.users.length > 0) {
                    state.user_exists_message = `${users.users[0].first_name} ${users.users[0].last_name} already has access to Aution365, double check they don't already have an account for this auctioneer before you continue.`

                } else {
                    state.user_exists_message = null
                }

            } catch (error) {
                console.error('error', error)

            } finally {
                state.user_check_loading = false
            }
        }

        watch (
            () => form.user.fields.email.value,
            (new_value) => {
                if (form.user.fields.email.value.length < state.user_check_min_length) return
                if (state.user_check_timeout) clearTimeout(state.user_check_timeout)
                state.user_check_timeout = setTimeout(getSimilarUsers, 300)

                emit('value_update', new_value)
            }
        )

        return {
            form,
            state
        }
    }
}
</script>